<template>
  <li class="accordion-parent" :class="{ 'active-accordion-parent': target === getActiveDataType }">
    <button :id="target" class="side-nav-list-button d-flex align-items-center" @click="
      callSetActiveDataType(target),
      toggleAccordion($event),
      (activeBtn = target)
      ">
      <svg version="1.1" class="mr-2" :class="{ visible: target === getActiveDataType }"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 40 40" style="enable-background: new 0 0 40 40; height: 40px" xml:space="preserve">
        <path class="st0" d="M20,9C13.9,9,9,13.9,9,20c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C31,13.9,26.1,9,20,9z M20,28.3
    c-4.6,0-8.3-3.7-8.3-8.3s3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3S24.6,28.3,20,28.3z" />
        <path class="outer"
          d="M20,4.5c-8.6,0-15.5,7-15.5,15.5c0,8.6,7,15.5,15.5,15.5c8.6,0,15.5-7,15.5-15.5
    C35.5,11.4,28.6,4.5,20,4.5z M20,31c-6.1,0-11-4.9-11-11c0-6.1,4.9-11,11-11c6.1,0,11,4.9,11,11C31,26.1,26.1,31,20,31z" />
        <path class="st1"
          d="M20,11.7c-4.6,0-8.3,3.7-8.3,8.3s3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3S24.6,11.7,20,11.7z" />
      </svg>
      <h5>
        <strong>
          {{ target | ripCode }}
        </strong>
      </h5>
      <span :class="{ visible: target === getActiveDataType }" class="icon-long-arrow-right color-light-blue ml-auto" />
    </button>
    <ul class="ml-2">
      <li v-for="button in getDataByType(target)" :key="button.id" class="ml-2 tt-list-border color-dark-blue">
        <button @click="
          loadSidePanelData(button);
        SideNavigationWideOpen();
        setActiveMapButton(button.id);
        zoomToPin($event);
        " tabindex="-1" aria-haspopup="true" class="tt-list-child-button" :id="button.id"
          :data-xcoord="button.imageXCoord" :data-ycoord="button.imageYCoord">
          {{ button.name | ripCode }}
        </button>
      </li>
    </ul>
  </li>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { dataFilters, accordionControl } from "src/mixins/mixins.js";
import { dragAndZoom } from "src/mixins/dragAndZoom.js";

import { createUrlString } from "src/store/helpers.js";

export default {
  name: "SideNavigationAccordion",
  props: ["target"],
  mixins: [dataFilters, accordionControl, dragAndZoom],
  computed: {
    ...mapGetters(["getDataByType", "getActiveDataType"]),
  },
  mounted() {
    // Toggle target (current element) if it is same as activeDataType
    if (this.getActiveDataType && this.target) {
      accordionControl.methods.toggleAccordion(
        "",
        this.getActiveDataType,
        this.target
      );
    }
  },
  watch: {
    getActiveDataType: {
      handler(newValue, oldValue) {
        if (!newValue) {
          // If activeDataType is cleared, use toggleAccordion to close every open accordion
          accordionControl.methods.toggleAccordion(
            "",
            oldValue,
            this.target,
            true
          );
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "SideNavigationWideOpen",
      "setActiveMapButton",
      "setActiveDataType",
    ]),
    callSetActiveDataType(target) {
      if (target != this.getActiveDataType) {
        // If different data type is clicked switch to that (e.g. Rakenne -> LVI-tekniikka)
        this.$router.push({
          name: "componentpage_datatype",
          params: {
            componentName: this.$router.currentRoute.params.componentName,
            view: this.$router.currentRoute.params.view,
            dataType: createUrlString(this.$options.filters.ripCode(target)),
          },
        });
      } else {
        // If same same data type e.g. Rakenne has been re-clocked, load default view
        this.$router.push({
          name: "componentpage_view",
          params: {
            componentName: this.$router.currentRoute.params.componentName,
            view: this.$router.currentRoute.params.view,
          },
        });
      }
    },
    loadSidePanelData(button) {
      // move focus to sidenavwide
      // Prompt vue-router to load new route, based on name and given parameters
      this.$router.push({
        name: "componentpage_subcomponent",
        params: {
          componentName: this.$router.currentRoute.params.componentName,
          view: this.$router.currentRoute.params.view,
          dataType: this.$router.currentRoute.params.dataType,
          subComponent: createUrlString(button.name.split(":").pop()),
        },
      });
      document.querySelector("#close-button").focus();
    },
  },
};
</script>
<style lang="scss" scoped>
.side-nav-list-button {
  border: none;
  background: none;
  margin-left: -32px !important;
  position: relative;
  text-align: left;
  width: 100%;

  svg {
    opacity: 0;
    transition: 0.2s opacity;

    &.visible {
      opacity: 1;
    }
  }

  .icon-long-arrow-right {
    opacity: 0;
    font-size: xx-large;
    transition: 0.2s opacity;

    &.visible {
      opacity: 1;
    }
  }

  h5 {
    pointer-events: none;
  }
}

ul {
  list-style: none;
  max-height: 0px;
  transition: max-height 0.2s ease-out;
  overflow: hidden;
  margin: 10px 0px;

  li {
    padding-left: 12px;

    button {
      text-align: left;
      background: none;
      border: none;
    }
  }
}

.tt-list-child-button {
  width: 100%;
  max-width: calc(100% - 24px);
  height: 100%;
  padding: 10px 0px 10px 8px;

  &:hover {
    background: #efefef;
  }
}

.tt-list-border:not(:last-of-type)::after {
  content: "";
  display: block;
  border-bottom: 1px solid #dfdfdf;
  max-width: calc(100% - 24px);
}

.outer {
  stroke: #fff;
  stroke-width: 1px;
  stroke-linejoin: round;
  fill: #00a9e0;
}

.st0 {
  fill: #fff;
}

.st1 {
  fill: #00a9e0;
}
</style>
